import { TLoginRequest } from "@/features/auth/types/loginRequest";
import { TLoginResponse } from "@/features/auth/types/loginResponse";
import { clientApi } from "@/utils/api";
import { logout } from "@/utils/logout";
import { AUTH_COOKIE_EXPIRES_DAYS, setToken } from "@/utils/token";
import { TApiRes } from "@/types/api";

import Cookies from "js-cookie";
import { ADMIN_EMAIL_KEY, ADMIN_USER_ID_KEY } from "@/utils/constants";

export const loginApi = async (payload: TLoginRequest): Promise<TLoginResponse> => {
  try {
    const {
      data: { data },
    } = await clientApi.post<TApiRes<TLoginResponse>>("/login", payload);

    logout();
    setToken(data.accessToken, data.refreshToken);
    Cookies.set(ADMIN_EMAIL_KEY, data.email, { expires: AUTH_COOKIE_EXPIRES_DAYS });
    Cookies.set(ADMIN_USER_ID_KEY, data.email, { expires: AUTH_COOKIE_EXPIRES_DAYS });
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
